/*
 * Asset URLs
 * -----------------------------------------------
 */
export const cdn = 'https://media.healthiq.com';

export function cdnUrl(path) {
  return `url('${cdn}/${path}')`;
}

export function cdmUrl(path) {
  return `url('${cdn}/marketing/${path}')`;
}

export function cdnWithoutUrl(path) {
  return `${cdn}/${path}`;
}

/*
 * Colors
 * -----------------------------------------------
 */
export const black = '#1A1C1F';
export const lightBlack = '#707475';
export const platinumBlack = '#1A1C1F';
export const darkBackground = '#1A1C1F';
export const blue = '#173A68';
export const darkBlue = '#173A68';
export const radiantBlue = '#128EE8';
export const skyBlue = '#C7E7FF';
export const darkerBlue = '#10294b';
export const lightBlue = '#4CA9ED';
export const lightestBlue = '#C7E7FF';
export const lochmaraBlue = '#0473c5';
export const green = '#05AB5B';
export const specialRateGreen = '#10715C'
export const orange = '#FF8D4A';
export const lightGreen = '#5ECD82';
export const darkGreen = '#3f8d59';
export const genoa = '#12705C';
export const red = '#E14747';
export const darkRed = '#cc4141';
export const gray = '#B1B7BA';
export const gray2 = '#7F8385';
export const darkGray = '#4A4A4A';
export const lightGray = '#CCCCCC';
export const lightGray2 = '#DEE2E5';
export const lightestGray = '#f3f3f3';
export const backgroundGray = '#F3F5F7';
export const placeholderGray = '#7c7c7c';
export const tableGray = '#DEE2E5';
export const borderGray = '#B1B7BA';
export const dividerGray = '#E5E9EB';
export const tcpaGray = '#7E8182';
export const tcpaGrayLegacy = '#898989';
export const white = '#FFFFFF';

export const sunfireFooterBlue = '#9EC9F0';
export const sunfireGreen = '#06884a';


/*
 * Size Constants
 * -----------------------------------------------
 */
export const pageMaxWidth = '915px';
export const cardMaxWidth = '600px';
export const cardContentMaxWidth = '460px';
export const headerMaxWidth = '900px';
export const questionSetInputMaxWidth = '300px'; // '230px'; // '215px';
export const marketingPageMaxWidth = '1440px !default';

/*
 * Media Query Cutoffs
 * -----------------------------------------------
 */
/* Primary Cutoffs */
export const mobileMax = '414px';
export const tabletMin = '415px';
export const tabletMax = '768px';
export const desktopMin = '769px';

/* iMac Device Sizes */
export const imac13inMax = '1280px';
export const imac15inMin = '1281px';
export const imac15inMax = '1440px';

// iOS Device Sizes
export const iphoneTabbarHeight = '120px';
export const iphone5Max = '320px';
export const iphone6Min = '321px';
export const iphone6Max = '375px';
export const iphone6plusMin = '376px';
export const iphone6plusMax = '414px';
export const ipadMin = '415px';
export const ipadMax = '768px';
export const ipadproMin = '769px';
export const ipadproMax = '1024px';

// Marketing Page Sizes
export const marketingPageMax = '1440px';
export const marketingPageContentMax = '1000px';
export const marketingMobilePage = mobileMax;
export const marketingMobileCuttoff = desktopMin;
export const marketingMobileCuttoffMax = tabletMax;
export const marketingDesktopBoxWidthMax = '1000px';

/*
 * Pre-defined Media Queries taken from (the) Monorepo
 */

export const MQ = {
  MOBILE_XS: `@media (max-width: ${iphone5Max})`,
  MOBILE: `@media (min-width: ${iphone6Min}) and (max-width: ${mobileMax})`,
  TABLET: `@media (min-width: ${tabletMin}) and (max-width: ${tabletMax})`,
  DESKTOP: `@media (min-width: ${desktopMin})`,
  SMALL_SCREENS: `@media (max-width: ${tabletMax})`
};
